import React from 'react';
import { PaymentCard } from './PaymentCard';
import { DonationCard } from './DonationCard';
import { CreditCard, Calendar, CheckCircle, Clock, XCircle, FileDown, Download, Search, Filter } from 'lucide-react';
interface Transaction {
  id: string;
  date: string;
  purpose: string;
  amount: string;
  status: 'paid' | 'pending' | 'cancelled';
  receiptUrl?: string;
}
const transactions: Transaction[] = [{
  id: '1',
  date: '15.01.2025',
  purpose: 'Членський внесок 2025 (₴500 + ₴150 осередок)',
  amount: '₴ 650',
  status: 'paid',
  receiptUrl: '#'
}, {
  id: '2',
  date: '10.01.2024',
  purpose: 'Членський внесок 2024 (₴500 + ₴150 осередок)',
  amount: '₴ 650',
  status: 'paid',
  receiptUrl: '#'
}, {
  id: '3',
  date: '05.03.2023',
  purpose: 'Реєстраційний збір — Чемпіонат Києва',
  amount: '₴ 150',
  status: 'paid',
  receiptUrl: '#'
}, {
  id: '4',
  date: '22.01.2023',
  purpose: 'Членський внесок 2023 (₴400 + ₴100 осередок)',
  amount: '₴ 500',
  status: 'paid',
  receiptUrl: '#'
}, {
  id: '5',
  date: '18.11.2022',
  purpose: 'Членський внесок 2022 (₴400 + ₴100 осередок)',
  amount: '₴ 500',
  status: 'paid',
  receiptUrl: '#'
}, {
  id: '6',
  date: '31.01.2026',
  purpose: 'Членський внесок 2026 (₴500 + ₴150 осередок)',
  amount: '₴ 650',
  status: 'pending'
}];
export function PaymentsPage() {
  return <div className="space-y-6" data-id="element-424">
      {/* Top Section: Status & Next Payment - 50/50 Split */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-425">
        {/* Status Panel */}
        <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-[0_4px_24px_rgba(0,0,0,0.04)] border border-slate-100 h-full flex flex-col" data-id="element-426">
          <h2 className="text-xl font-bold text-slate-900 mb-2" data-id="element-427">
            Статус оплати
          </h2>
          <p className="text-slate-500 mb-6" data-id="element-428">
            Ваш поточний статус членських внесків. Своєчасна оплата гарантує
            участь у змаганнях та право голосу на зборах федерації.
          </p>

          <div className="flex flex-col gap-4 mt-auto" data-id="element-429">
            <div className="flex items-center gap-3 p-4 rounded-xl bg-green-50 border border-green-100" data-id="element-430">
              <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center text-green-600 shadow-sm flex-shrink-0" data-id="element-431">
                <CheckCircle className="w-5 h-5" data-id="element-432" />
              </div>
              <div data-id="element-433">
                <p className="text-sm font-bold text-slate-800" data-id="element-434">
                  2025 рік сплачено
                </p>
                <p className="text-xs text-slate-500" data-id="element-435">Дійсний до 31.12.2025</p>
              </div>
            </div>

            <div className="flex items-center gap-3 p-4 rounded-xl bg-blue-50 border border-blue-100" data-id="element-436">
              <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center text-blue-600 shadow-sm flex-shrink-0" data-id="element-437">
                <Calendar className="w-5 h-5" data-id="element-438" />
              </div>
              <div data-id="element-439">
                <p className="text-sm font-bold text-slate-800" data-id="element-440">
                  Наступний платіж
                </p>
                <p className="text-xs text-slate-500" data-id="element-441">Січень 2026</p>
              </div>
            </div>
          </div>
        </div>

        {/* Payment Card - Now takes full half width */}
        <div className="h-full" data-id="element-442">
          <PaymentCard data-id="element-443" />
        </div>
      </div>

      {/* Donation Section - Full Width */}
      <DonationCard data-id="element-444" />

      {/* Bottom Section: Payment History */}
      <div className="bg-white rounded-2xl shadow-[0_4px_24px_rgba(0,0,0,0.04)] border border-slate-100 overflow-hidden" data-id="element-445">
        {/* Header */}
        <div className="p-6 border-b border-slate-100 flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-446">
          <div className="flex items-center gap-3" data-id="element-447">
            <div className="w-10 h-10 rounded-xl bg-slate-50 flex items-center justify-center text-slate-500" data-id="element-448">
              <CreditCard className="w-5 h-5" data-id="element-449" />
            </div>
            <div data-id="element-450">
              <h3 className="text-lg font-bold text-slate-900" data-id="element-451">
                Історія платежів
              </h3>
              <p className="text-sm text-slate-500" data-id="element-452">
                Всі транзакції по членських внесках
              </p>
            </div>
          </div>

          <div className="flex items-center gap-2" data-id="element-453">
            <button className="p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-50 rounded-lg transition-colors" data-id="element-454">
              <Search className="w-5 h-5" data-id="element-455" />
            </button>
            <button className="flex items-center gap-2 px-3 py-2 text-sm font-medium text-slate-600 bg-slate-50 hover:bg-slate-100 rounded-lg border border-slate-200 transition-colors" data-id="element-456">
              <Filter className="w-4 h-4" data-id="element-457" />
              Фільтр
            </button>
            <button className="flex items-center gap-2 px-3 py-2 text-sm font-medium text-blue-600 bg-blue-50 hover:bg-blue-100 rounded-lg border border-blue-100 transition-colors" data-id="element-458">
              <Download className="w-4 h-4" data-id="element-459" />
              Експорт
            </button>
          </div>
        </div>

        {/* Table */}
        <div className="overflow-x-auto" data-id="element-460">
          <table className="w-full text-left border-collapse" data-id="element-461">
            <thead data-id="element-462">
              <tr className="bg-slate-50/50 border-b border-slate-100" data-id="element-463">
                <th className="py-4 px-6 text-xs font-semibold text-slate-500 uppercase tracking-wider" data-id="element-464">
                  Дата
                </th>
                <th className="py-4 px-6 text-xs font-semibold text-slate-500 uppercase tracking-wider" data-id="element-465">
                  Призначення
                </th>
                <th className="py-4 px-6 text-xs font-semibold text-slate-500 uppercase tracking-wider" data-id="element-466">
                  Сума
                </th>
                <th className="py-4 px-6 text-xs font-semibold text-slate-500 uppercase tracking-wider" data-id="element-467">
                  Статус
                </th>
                <th className="py-4 px-6 text-xs font-semibold text-slate-500 uppercase tracking-wider text-right" data-id="element-468">
                  Квитанція
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-50" data-id="element-469">
              {transactions.map(tx => <tr key={tx.id} className="hover:bg-slate-50/50 transition-colors group" data-id="element-470">
                  <td className="py-4 px-6 text-sm font-medium text-slate-900 whitespace-nowrap" data-id="element-471">
                    {tx.date}
                  </td>
                  <td className="py-4 px-6 text-sm text-slate-600" data-id="element-472">
                    {tx.purpose}
                  </td>
                  <td className="py-4 px-6 text-sm font-bold text-slate-900 whitespace-nowrap" data-id="element-473">
                    {tx.amount}
                  </td>
                  <td className="py-4 px-6 whitespace-nowrap" data-id="element-474">
                    <StatusBadge status={tx.status} data-id="element-475" />
                  </td>
                  <td className="py-4 px-6 text-right whitespace-nowrap" data-id="element-476">
                    {tx.status === 'paid' && <button className="inline-flex items-center justify-center p-2 rounded-lg text-slate-400 hover:text-blue-600 hover:bg-blue-50 transition-colors" title="Завантажити квитанцію" data-id="element-477">
                        <FileDown className="w-4 h-4" data-id="element-478" />
                      </button>}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        {/* Mobile View Footer */}
        <div className="p-4 border-t border-slate-100 bg-slate-50/30 text-center" data-id="element-479">
          <button className="text-sm font-medium text-blue-600 hover:text-blue-700 transition-colors" data-id="element-480">
            Завантажити більше
          </button>
        </div>
      </div>
    </div>;
}
function StatusBadge({
  status
}: {
  status: Transaction['status'];
}) {
  switch (status) {
    case 'paid':
      return <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-green-50 text-green-700 border border-green-100" data-id="element-481">
          <CheckCircle className="w-3.5 h-3.5" data-id="element-482" />
          Сплачено
        </span>;
    case 'pending':
      return <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-orange-50 text-orange-700 border border-orange-100" data-id="element-483">
          <Clock className="w-3.5 h-3.5" data-id="element-484" />
          Очікує
        </span>;
    case 'cancelled':
      return <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-red-50 text-red-700 border border-red-100" data-id="element-485">
          <XCircle className="w-3.5 h-3.5" data-id="element-486" />
          Скасовано
        </span>;
    default:
      return null;
  }
}